export const screenDevice: MediaDeviceInfo = {
  kind: 'videoinput',
  deviceId: 'screen',
  label: 'Tela',
  groupId: '',
  toJSON: () => JSON.stringify(screenDevice),
};
